import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import QueueDashboard from './components/dashboard.vue';
import CurveLine from './components/fragments/curve-line.vue';
import ChartTotal from './components/fragments/chart-total.vue';
import ChartCross from './components/fragments/chart-cross.vue';
import ChartTime from './components/fragments/chart-time.vue';
import ChartSpeed from './components/fragments/chart-speed.vue';
import { QueueModule } from '@blade-sxp/monitor/store/queue';
import { AlarmWebsocket } from '@blade/common/utils/websocket';
let default_1 = class extends Vue {
    activeName = 'first';
    current = 0;
    disUrl = require('@blade-sxp/monitor/assets/image/dis.png');
    data = '';
    ws;
    polling;
    summaryList = [];
    wsUrl = this.mapUrl();
    // @Provide()
    // daySummary = this.summaryList;
    async mounted() {
        this.ws = new AlarmWebsocket(this.wsUrl);
        this.ws.setOnMessage(this.onMessage);
        // this.getDaySummary();
    }
    onMessage(event) {
        const data = JSON.parse(event.data);
        if (data.messageType === 'UMC_QUEUE_DASHBOARD') {
            this.summaryList.pop();
            this.summaryList.push(data.content);
        }
        if (data.messageType === 'UMC_QUEUE_TASK') {
            this.$refs['queue']?.handleCircles(data.content);
        }
    }
    mapUrl() {
        const res = process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_REALTIME_WS
            : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`;
        return res || '';
    }
    async getDaySummary() {
        try {
            const res = await QueueModule.getDaySummay();
            console.log('res:', res.summary.list);
            const mock = res.summary.list;
            // const data = {
            //   averagePassSpeed: 100,
            //   averagePassSpeedHistoryList: [10, 20, 30, 10, 10],
            //   averagePassTime: 100,
            //   averageTimePassQueueHistoryList: [100, 200, 10, 30, 50],
            //   queueingCountHistoryList: [10, 10, 20, 30, 40, 10, 10, 20, 30, 40, 10, 10, 20, 30, 40, 10, 10, 20, 30, 40],
            //   dayOnDayPassCountGrowth: 10,
            //   queueingCount: 10,
            //   totalPassCountPerDay:10,
            // };
            if (this.summaryList.length > 0) {
                return;
            }
            const daySummary = { totalPassCountPerDay: mock[0].totalPassCountCurrentDay, queueingCount: mock[0].queueingCount };
            this.summaryList.push(daySummary);
        }
        catch (e) {
            console.log('e:', e);
        }
    }
    initPolling() {
        this.polling = setInterval(() => this.getDaySummary(), 1000 * 5);
    }
    beforeDestroy() {
        console.log('destroy');
        clearInterval(this.polling);
        this.ws.close();
        this.ws = undefined;
    }
};
default_1 = __decorate([
    Component({
        name: 'Dashboard',
        components: { 'queue-dashboard': QueueDashboard, CurveLine, ChartTotal, ChartCross, ChartTime, ChartSpeed },
        i18n: {
            messages: {
                'en-us': {},
                zh: {},
            },
        },
    })
], default_1);
export default default_1;
